export default __webpack_public_path__ + "static/media/material-97.fe5b1967.svg";